import * as Yup from 'yup';

import { DateTime } from 'luxon';

import CustomerInfo from './Components/CustomerInfo';
import Services from './Components/Services';
import Products from './Components/Products';
import Inventory from './Components/Inventory';
import Repairs from './Components/Repairs';
import OpenInvoices from '../Payments/Components/OpenInvoices';
import Adjustments from './Components/Adjustments';
import ActionBar from './Components/ActionBar';
import CustomOrder from './Components/CustomOrder';

import { nanoid } from 'nanoid';


const fields = [
  // { 
  //   fieldType: "debounceSearchSolo",
  //   formFieldType: "select",
  //   select: [],
  //   name: "customer_id",
  //   label: "Select Customer",
  //   url: "customers",
  //   fieldName: "customer_id",
  //   displayField: "full_name",
  //   formUpdates: [{name: "client_name", field: "full_name"}],
  //   setDisplayField: "client_name",
  //   size: {xs: 12, lg: 12},
  // },
  {
    fieldType: "formField",
    formFieldType: "date",
    name: "date",
    label: "Invoice Date",
    type: "date",
    size: {xs: 12, lg: 3},
  },
  {
    fieldType: "formField",
    formFieldType: "date",
    name: "due_date",
    label: "Due Date",
    type: "date",
    size: {xs: 12, lg: 3},
  },
  { 
    fieldType: "debounceSearchSolo",
    formFieldType: "select",
    select: [],
    name: "sales_rep_id",
    label: "Select Sales Rep",
    url: "users",
    conditionStr: '&is_active[$eq]=true',
    fieldName: "user_id",
    displayField: "display_name",
    formUpdates: [{name: "sales_rep", field: "display_name"}],
    size: {xs: 12},
  },
  {
    fieldType: "divider",
    header: "Checkout Details",
    name: "checkout_details",
    size: {xs: 12, lg: 12},
  },
  { 
    fieldType: "Component",
    Component: <CustomerInfo />,
    name: "customer_info",
    size: {xs: 12, lg: 12},
  },
  { 
    fieldType: "Component",
    Component: <Inventory />,
    name: "wigs",
    size: {xs: 12, lg: 12},
  },
  { 
    fieldType: "Component",
    Component: <Services />,
    name: "services",
    size: {xs: 12, lg: 12},
  },
  { 
    fieldType: "Component",
    Component: <Products />,
    name: "products",
    size: {xs: 12, lg: 12},
  },
  { 
    fieldType: "Component",
    Component: <Repairs />,
    name: "repairs",
    size: {xs: 12, lg: 12},
  },
  { 
    fieldType: "Component",
    Component: <CustomOrder />,
    name: "custom_orders",
    size: {xs: 12, lg: 12},
  },
  { 
    fieldType: "Component",
    Component: <Adjustments />,
    name: "adjustments",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "Component",
    Component: <ActionBar />,
    name: "action_bar",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "divider",
    header: "Open Invoices",
    name: "open_invoices_divider",
    checkDisplayField: (values) => { return !!values?.invoice_id},
    size: {xs: 12, lg: 12},
  },
  { 
    fieldType: "Component",
    Component: <OpenInvoices />,
    name: "open_invoices",
    checkDisplayField: (values) => { return !!values?.invoice_id},
    size: {xs: 12, lg: 12},
  }
]

const initialValues = {
  
  appointment_id: "",
  customer_id: "",
  final_balance: 0,
  services: [
  ],
  products: [
  ],
  wigs: [],
  repairs: [],
  adjustments: [],
  custom_orders: [],
  apply_credit: false,
  total_amount: 0,
  date: "",
  due_date: "",
  payment_date: "",
  method: '',
  info: '',
  amount: "",
  notes: '',
  card_num: '',
  exp: '',
  cvv: '',
  use_cc_fee: false,
  cc_rate: 0,
  entry: 'manual',
  processed: false
}

const additionalState = {
  customer: {},
  client_name: '',
  new_payments: [],
  applied_payments: [],
  sales_rep: ""
}

const schema = Yup.object().shape({
  // services: Yup.array().min(1, "Please select at least one service").required("Please select at least one service"),
});

const parseData = (data) => {
  const parsed = {
    ...data,
    method: '',
    info: '',
    amount: "",
    notes: '',
    card_num: '',
    exp: '',
    cvv: '',
    entry: 'manual',
    processed: false,
    apply_credit: false,
  };
  // parsed.date = DateTime.fromISO(data.date);
  // parsed.due_date = DateTime.fromISO(data.due_date);
  parsed.customer_id = data.customer_id.toString();
  return parsed
}

export { fields, schema, initialValues, additionalState, parseData };